import type { PrintDataFields } from "@repo/print-pdf/arbre/print/template";

/** Inventaire d'exemple pour l'aperçu de l'éditeur (jusqu'au choix d'un vrai inventaire). */
export const SAMPLE_PRINT_DATA = {
  organizationName: "Racines et Cimes",
  organizationAddress: "12 avenue des Tilleuls",
  organizationCity: "75000 Paris",
  organizationSiret: "123 456 789 00012",
  organizationLogo: null,
  user: { prenom: "Démo", nom: "Admin" },
  formattedDate: "21/10/2026",
  genreLatin: "Quercus",
  especeLabel: "Chêne pédonculé",
  addressLine: "1 rue de la Paix",
  code_site: "S1",
  especeLatin: "robur",
  num_sujet: "1",
  cultivar: "",
  gps: "48.85, 2.35",
  hauteur: "12",
  diametre: "40",
  age_estime: "80 ans",
  caracteristiques: {
    stade_dev: "Adulte",
    critere: "Oui",
    port_arbre: "Port libre",
    caract_tronc: "Tronc unique",
    caract_pied: "Terre, litière",
    implantation: "Alignement",
    domaine: "Public",
    situation: "",
    accessibilite: "Facile",
  },
  environnement: {
    proximite: "Bâti",
    nuisance: "",
    taux_freq: "Forte",
    type_passage: "Piéton",
    dictLabel: "Non",
  },
  etatSanitaire: {
    collet: "Bon",
    tronc: "Moyen",
    houppier: "Bon",
    general: "Moyen",
    general_complementaire: false,
  },
  defautsMecaniques: {
    collet: "Aucun défaut",
    tronc: "Cavité à la base",
    houppier: "Bois mort",
  },
  risque: {
    collet: "faible",
    tronc: "modéré",
    houppier: "faible",
    general: "modéré",
  },
  travaux: {
    abattage: "",
    travaux_collet: "Aucun",
    travaux_tronc: "Surveillance",
    travaux_houppier: "Élagage léger",
    date_travaux: "",
    date_pro_visite: "21/10/2027",
  },
  img1: null,
  img2: null,
  img3: null,
  comments: "Arbre remarquable à surveiller lors du prochain passage.",
  beva: "4 200",
  dictRequired: "Non",
} as unknown as PrintDataFields;
